import styled from 'styled-components';

export const FulfilmentWrapper = styled.div`
  position: relative;
`;
